<template>
  <v-dialog :value="value" persistent max-width="800px">
    <nv-form
      v-if="item != null"
      :errors="formErrors"
      :title="formTitle"
      :loading="loading"
      @cancel="formCancel"
      @nv-submit="formSubmit"
    >
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            ref="value"
            v-model="item.value"
            :rules="rules.value"
            :disabled="item.read_only"
            data-cy="value-text"
            label="Value"
            hint="The parameter value"
            counter="255"
            required
          />
        </v-col>

        <encoding-select ref="encoding" v-model="item.encoding" :disabled="item.read_only" />

        <v-col cols="12" sm="4">
          <v-select
            v-model="item.status"
            :rules="rules.status"
            :items="enumParamStatuses"
            label="Status"
            required
            multi-line
          />
        </v-col>
      </v-row>
    </nv-form>
  </v-dialog>
</template>

<script>
import HTTP from '@/api/dog';
import { FormMixin, enumFetch } from '@nielsen-media/ui-toolkit-vue-api';
import EncodingSelect from '@/components/master_parameters/EncodingSelect.vue';
import { rules } from './validations';

export default {
  components: { EncodingSelect },
  mixins: [FormMixin],
  data: () => ({
    enumParamStatuses: [],
    rules,
    formContext: 'Parameter',
    originalItem: null,
  }),
  created() {
    this.enumFetch(HTTP, {
      enumParamStatuses: '/parameters/enum/statuses',
    });
  },
  methods: {
    formReady() {
      this.originalItem = { ...this.editing };
    },
    formSave() {
      const updatedItem = {
        ...this.originalItem,
        value: this.item.value,
        encoding: this.item.encoding,
        status: this.item.status,
      };
      this.$emit('saved', updatedItem);
      this.formCancel();
      return Promise.resolve();
    },
    enumFetch,
  },
};
</script>
